/* =============================================================================
   Contador de unidades en el boton de agregar al carrito — Sumitelco, 2026-08-12

   Cuando un producto ya esta en el carrito, su boton muestra una burbuja con las
   unidades que lleva. Se alimenta de dos sitios:

     1. al cargar la pagina, leyendo /cart.js una sola vez
     2. despues, del evento 'cart-update' que el propio tema dispara en
        assets/theme.js:3439 con el carrito completo en detail

   No hace ninguna peticion extra cuando el cliente agrega: aprovecha la que el
   tema ya hace. La correspondencia es por id de variante, que es lo que Shopify
   devuelve en cada linea del carrito y lo que el formulario de la tarjeta manda.

   PARA REVERTIR: quitar el <script> de layout/theme.liquid y borrar este archivo.
   ========================================================================== */
(function () {
  'use strict';

  var SEL_BOTON = '.stc-atc';

  function variantesEnCarrito(cart) {
    var m = {};
    if (!cart || !cart.items) return m;
    for (var i = 0; i < cart.items.length; i++) {
      var it = cart.items[i];
      m[String(it.variant_id)] = (m[String(it.variant_id)] || 0) + it.quantity;
    }
    return m;
  }

  function varianteDe(boton) {
    // el id de variante viaja en el input oculto del formulario que envuelve al boton
    var f = boton.closest('form');
    if (!f) return null;
    var i = f.querySelector('input[name="id"]');
    return i && i.value ? String(i.value) : null;
  }

  function pintar(cart) {
    var mapa = variantesEnCarrito(cart);
    var botones = document.querySelectorAll(SEL_BOTON);
    for (var i = 0; i < botones.length; i++) {
      var b = botones[i];
      var v = varianteDe(b);
      var n = v ? mapa[v] : 0;
      var burbuja = b.querySelector('.stc-qty');
      if (!burbuja) continue;
      if (n > 0) {
        /* Escribir textContent reemplaza el nodo de texto AUNQUE la cadena sea la
           misma, y eso es una mutacion de childList: el observador de mas abajo la
           ve, programa otro arranque(), que vuelve a pintar y a mutar. Con un
           producto del carrito a la vista era un bucle infinito de peticiones a
           /cart.js cada 400 ms. Escribir solo si cambia lo corta. */
        var texto = n > 99 ? '99+' : String(n);
        if (burbuja.textContent !== texto) burbuja.textContent = texto;
        b.classList.add('has-qty');
        b.setAttribute('aria-description', n === 1 ? '1 unidad en el carrito'
                                                   : n + ' unidades en el carrito');
      } else {
        b.classList.remove('has-qty');
        b.removeAttribute('aria-description');
      }
    }
  }

  /* Una sola petición compartida a /cart.js (26-oct-2026). Antes cada mutación del DOM que veía el
     observador lanzaba otro fetch (4-6 por carga). Ahora la promesa se guarda y se reutiliza, y solo se
     invalida cuando el carrito cambia de verdad: el evento 'cart-update' del tema (trae el carrito) o una
     petición a /cart/add|change|update|clear vista por PerformanceObserver (cajón, página del carrito). */
  var carritoMemo = null;

  function leerCarrito() {
    if (!carritoMemo) {
      carritoMemo = fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; })
        .then(function (c) { if (!c) carritoMemo = null; return c; });   /* si falla, se reintenta luego */
    }
    return carritoMemo;
  }

  function arranque() {
    leerCarrito().then(function (c) { if (c) pintar(c); });   /* si falla, simplemente no hay burbujas */
  }

  // El tema ya avisa con el carrito completo tras cada alta o cambio de cantidad.
  document.addEventListener('cart-update', function (ev) {
    var c = ev && ev.detail;
    c = c && (c.items ? c : c.cart);
    if (c && c.items) { carritoMemo = Promise.resolve(c); pintar(c); }
    else { carritoMemo = null; arranque(); }
  });

  // Cambios del carrito que no emiten 'cart-update': invalidar la promesa y volver a pintar.
  try {
    new PerformanceObserver(function (lista) {
      var es = lista.getEntries();
      for (var i = 0; i < es.length; i++) {
        if (/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(es[i].name)) {
          carritoMemo = null; clearTimeout(pendiente); pendiente = setTimeout(arranque, 400); return;
        }
      }
    }).observe({ type: 'resource' });
  } catch (e) { /* sin PerformanceObserver queda el evento 'cart-update' */ }

  // Las tarjetas de los carruseles se clonan y los filtros repintan la rejilla:
  // cuando aparecen botones nuevos hay que volver a pintarlos.
  var pendiente = null;
  var obs = new MutationObserver(function () {
    clearTimeout(pendiente);
    pendiente = setTimeout(arranque, 400);
  });

  function iniciar() {
    arranque();
    try {
      obs.observe(document.body, { childList: true, subtree: true });
    } catch (e) { /* sin observador, el contador solo se actualiza por evento */ }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }
})();

/* =============================================================================
   Numero de favoritos en las barras — Sumitelco, 2026-08-25

   El tema guarda los favoritos en localStorage['wishlistItem'] como un array
   JSON, pero no pinta ningun contador: la clase .wishlist-count-bubble existe
   en el tema y el atributo data-wishlist-count queda siempre vacio. Esto lo
   rellena, con el mismo aspecto que la burbuja del carrito, en la barra
   superior (los tres headers activos) y en la inferior del movil.

   Es todo del lado del navegador, sin servicios externos: los favoritos viven
   en el propio navegador del cliente, no en su cuenta de Shopify.

   PARA REVERTIR: borrar este bloque y quitar los <div data-smt-wishlist-bubble>
   de los tres headers y de sections/halo-toolbar-mobile.liquid.
   ========================================================================== */
(function () {
  'use strict';

  var CLAVE = 'wishlistItem';

  function contar() {
    try {
      var crudo = localStorage.getItem(CLAVE);
      if (!crudo) return 0;
      var lista = JSON.parse(crudo);
      return Array.isArray(lista) ? lista.length : 0;
    } catch (e) {
      return 0;   // modo privado o dato corrupto: se trata como vacio
    }
  }

  function pintar() {
    var n = contar();
    var burbujas = document.querySelectorAll('[data-smt-wishlist-bubble]');
    for (var i = 0; i < burbujas.length; i++) {
      var b = burbujas[i];
      /* Misma precaucion que en el contador del carrito: escribir textContent sin
         comprobar mutaria el DOM en cada repintado y despertaria a aquel
         observador, provocando una peticion a /cart.js por cada favorito tocado. */
      var t = b.querySelector('[data-wishlist-count]');
      var texto = n > 99 ? '99+' : String(n);
      if (t && t.textContent !== texto) t.textContent = texto;
      var sr = b.querySelector('[data-smt-wishlist-sr]');
      var leido = n === 1 ? '1 producto en favoritos' : n + ' productos en favoritos';
      if (sr && sr.textContent !== leido) sr.textContent = leido;
      b.hidden = (n === 0);
    }
  }

  /* El tema SI avisa, y lo hace justo despues de escribir en localStorage
     (assets/theme.js): al anadir dispara 'updatewishlistmail' y al quitar
     'updatepagination', ambos sobre document. Escuchar eso es exacto; esperar
     un tiempo fijo tras el clic era adivinar. Se mantiene el clic como red de
     seguridad por si alguna ruta del tema no emitiera evento. */
  document.addEventListener('updatewishlistmail', pintar);
  document.addEventListener('updatepagination', pintar);

  function alPulsar(e) {
    if (!e.target || !e.target.closest) return;
    if (e.target.closest('[data-wishlist], [data-wishlist-remove-item], .wishlist-icon')) {
      setTimeout(pintar, 350);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', pintar);
  } else {
    pintar();
  }
  document.addEventListener('click', alPulsar, true);
  window.addEventListener('storage', function (e) { if (e.key === CLAVE) pintar(); });
  window.addEventListener('pageshow', pintar);   // volver con el boton atras
})();
